<template>
    <div class="card-select-feature" v-if="(plan.selectFeatures || []).length > 0">
        <a-select v-model="cloneSelectedFeatureIndex" :dropdownClassName="'select-feature-dropdown'">
            <a-select-option 
                v-for="(selectFeature, index) of plan.selectFeatures" 
                :value="index" 
                :key="index" 
                :disabled="selectFeature.isDisabled"
                :class="{ 'has-active-tick': isFeatureActive(selectFeature.count) }"
            >
                {{ getOptionText(selectFeature.count) }}
            </a-select-option>
        </a-select>
        <span
            v-if="period !== 'monthly' && getTotalPlanCount() > 0"
            class="active-tier-badge-inline"
            v-tippy="{ content: $t('billing.activePlanCountTooltip', { count: getTotalPlanCount() }) }"
        >
            {{ getTotalPlanCount() }}
        </span>
    </div>
</template>
<script>
export default {
    type: "CardSelectFeature",
    props: {
        period: {
            type: String,
            required: true,
        },
        plan: {
            type: Object,
            required: true,
        },
        selectedFeatureIndex: {
            type: Number,
            default: 0,
        },
        currentPlans: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        cloneSelectedFeatureIndex: 0,
    }),
    mounted() {
        this.cloneSelectedFeatureIndex = this.selectedFeatureIndex;
    },
    methods: {
        calculateCount(count) {
            const calc = {
                monthly: {
                    automation: (count * 1),
                    supsis: (count * 1),
                    chatbot: (count * 1),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                "monthly-3": {
                    automation: (count * 3),
                    supsis: (count * 1),
                    chatbot: (count * 3),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                "monthly-6": {
                    automation: (count * 6),
                    supsis: (count * 1),
                    chatbot: (count * 6),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                annual: {
                    automation: (count * 12),
                    supsis: (count * 1),
                    chatbot: (count * 12),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
                "annual-2": {
                    automation: (count * 24),
                    supsis: (count * 1),
                    chatbot: (count * 24),
                    mail: (count * 1),
                    web: (count * 1),
                    "voice-agent": (count * 1),
                },
            };
            return calc[this.period][this.plan.type];
        },
        getOptionText(count) {
            var typeKeys = {
                automation: "billing.cardSelectResourceAutomation",
                supsis: "billing.cardSelectResourceSupsis",
                chatbot: "billing.cardSelectResourceChatbot",
                mail: "billing.cardSelectResourceMail",
                web: "billing.cardSelectResourceWeb",
                "voice-agent": "billing.cardSelectResourceVoiceAgent",
            };
            var periodKeys = {
                monthly: "billing.cardSelectPeriodPerMonth",
                "monthly-3": "billing.cardSelectPeriodPer3Months",
                "monthly-6": "billing.cardSelectPeriodPer6Months",
                annual: "billing.cardSelectPeriodPerYear",
                "annual-2": "billing.cardSelectPeriodPer2Years",
            };
            return (
                this.calculateCount(count) +
                " " +
                this.$t(typeKeys[this.plan.type]) +
                " " +
                this.$t(periodKeys[this.period])
            );
        },
        /**
         * Bu plandan ve period'dan toplam kaç aktif abonelik olduğunu hesaplar
         * @returns {Number} Toplam aktif plan sayısı (period'a göre filtrelenmiş)
         */
        getTotalPlanCount() {
            if (!this.currentPlans || this.currentPlans.length === 0) {
                return 0;
            }
            
            const planType = this.plan.dynamicType || this.plan.type;
            return this.currentPlans.filter(cp => 
                (cp.planType === planType) &&
                (cp.planId === this.plan._id) &&
                (cp.period === this.period)
            ).length;
        },
        /**
         * Bu feature'ın bu period'da aktif olup olmadığını kontrol eder
         * @param {Number} count - Feature'ın count değeri
         * @returns {Boolean} Aktif mi değil mi
         */
        isFeatureActive(count) {
            if (!this.currentPlans || this.currentPlans.length === 0) {
                return false;
            }
            
            const planType = this.plan.dynamicType || this.plan.type;
            return this.currentPlans.some(cp => 
                (cp.planType === planType) &&
                (cp.planId === this.plan._id) &&
                (cp.period === this.period) &&
                (cp.details?.maxUsageCount === count)
            );
        },
    },
    watch: {
        selectedFeatureIndex(val) {
            if(val === this.cloneSelectedFeatureIndex) return;
            this.cloneSelectedFeatureIndex = val;
        },
        cloneSelectedFeatureIndex(val) {
            if(val === this.selectedFeatureIndex) return;
            this.$emit("selectedFeature", val);
        },
    },
};
</script>
<style lang="scss">
.card-select-feature {
    width: 100%;
    position: relative;

    .ant-select {
        width: 100%;
    }

    .ant-select-selection {
        border: 1px solid #22272d !important;
        background: white !important;
        border-radius: 3px !important;
        padding: 4px 4px;
        padding-right: 50px !important; /* Badge için yer aç */
    }

    .ant-select-selection-selected-value {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    /* Seçili değerde tick gizle */
    .ant-select-selection .has-active-tick::after {
        display: none;
    }

    .active-tier-badge-inline {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 22px;
        height: 22px;
        padding: 0 6px;
        background: #f79d65;
        color: white;
        border-radius: 11px;
        font-size: 11px;
        font-weight: 700;
        z-index: 1;
    }

}

/* Global dropdown stilleri */
.select-feature-dropdown {
    .ant-select-dropdown-menu-item {
        padding: 8px 12px !important;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &.has-active-tick::after {
            content: "✓";
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            height: 18px;
            background: #f79d65;
            color: white;
            border-radius: 50%;
            font-size: 12px;
            font-weight: 700;
            margin-left: 8px;
        }
    }
}
</style>
